import StreamPage from "./StreamPage";

export default StreamPage;